import { bootstrapApplication } from '@angular/platform-browser';
import { provideRouter, withHashLocation } from '@angular/router';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';

import { AddinRootComponent } from '../src/app/add-in-root/addin-root.component';
import { addinRoutes } from '../src/app/add-in-root/addin.routes';
import { provideTranslateService } from '@ngx-translate/core';
import { provideTranslateHttpLoader } from '@ngx-translate/http-loader';
import { SharedModule } from '../src/app/shared/shared-module';
import { importProvidersFrom } from '@angular/core';
import { ConfirmationService, MessageService } from 'primeng/api';

declare const Office: any;
const timestamp = new Date().getTime();

Office.onReady(() => {
  console.log('Office.js loaded:', typeof Office !== 'undefined');
  console.log('window.history', window.history);
  console.log('replaceState', window.history?.replaceState);
  console.log('typeof replaceState', typeof window.history?.replaceState);
  console.log(Office.context.host);
  console.log(Office.context.platform);
  console.log(Office.context.diagnostics);
  console.log(navigator.userAgent);

  console.log('window.history =', window.history);
  console.log('replaceState =', window.history?.replaceState);
  console.log('typeof replaceState =', typeof window.history?.replaceState);

  console.log(Object.getPrototypeOf(window.history)?.constructor?.name);

  const patchHistory = () => {
    try {
      const h: any = (window as any).history;
      if (!h) return;

      if (typeof h.replaceState === 'function') return;

      // Try to bind to parent history only if accessible (same-origin).
      let boundToParent = false;
      try {
        if (window.parent && window.parent !== window) {
          const ph: any = (window.parent as any).history;
          if (ph && typeof ph.replaceState === 'function') {
            h.replaceState = ph.replaceState.bind(ph);
            h.pushState = ph.pushState.bind(ph);
            boundToParent = true;
          }
        }
      } catch (_) {
        // Accessing window.parent can throw on cross-origin frames. Ignore.
        boundToParent = false;
      }

      if (!boundToParent) {
        Object.defineProperty(h, 'replaceState', { value: () => {}, configurable: true });
        Object.defineProperty(h, 'pushState', { value: () => {}, configurable: true });
      }
    } catch (e) {
      console.warn('patchHistory failed', e);
    }
  };

  patchHistory();

  bootstrapApplication(AddinRootComponent, {
    providers: [
      provideRouter(addinRoutes, withHashLocation()),
      provideHttpClient(withInterceptorsFromDi()),
      importProvidersFrom(SharedModule),
      provideTranslateService({
        loader: provideTranslateHttpLoader({
          prefix: '/assets/i18n/',
          suffix: `.json?v=${timestamp}`,
        }),
        fallbackLang: 'de',
        lang: 'de',
      }),
      ConfirmationService,
      MessageService,
    ],
  }).catch(err => {
    console.error(err);
    console.error(err.ngTokenPath);
  });
});
